import Vue from 'vue';

import App from './App.vue';
import VueLocalStorage from 'vue-localstorage';
import router from './router';
import store from './store/';

import '@/assets/css/app.pcss';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@/assets/fonts/myfont/entry';
import Element from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import locale from '@/assets/element-ui/lib/locale/lang/ja';

import './permission';
import '@/global';
import 'luxon';

window.Vue = Vue;
Vue.config.productionTip = true;
Vue.use(VueLocalStorage);

Vue.use(Element, {
  locale,
  size: 'medium',
});

window.vueinstans = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
